import * as React from "react";
import { SingleNavMenuLinkSection as ISingleNavMenuLinkSection } from "../../../pages/identity/useNavMenu";
import { BasePathContext } from "../../../reactContexts/basePathContext";
import { useNavigate } from "react-router-dom";
import { useSingleNavMenuContext } from "./useSingleNavMenuContext";
import clsx from "clsx";
import { CpErrorWarningArrayIconLink } from "../../../pages/gvc/testNewForm/CpErrorWarningArrayIcon";

interface Props {
  link: ISingleNavMenuLinkSection;
  index: number;
}
export const SingleNavMenuLinkSection: React.FC<Props> = ({ link, index }) => {
  const basePath = React.useContext(BasePathContext);
  const navigate = useNavigate();

  const { activeLinkId, scrollToSection } = useSingleNavMenuContext();

  const href = React.useMemo(() => {
    return `${basePath}${link.page}/${link.section}`;
  }, [basePath, link, link.page, link.section]);

  return (
    <a
      data-link-id={`${link.id}`}
      data-label={`${link.label.toLowerCase()}`}
      className={clsx(`relative ml-${4 * (link.sub || 0)}`, { active: activeLinkId === link.id })}
      onClick={(e) => {
        if (e.button === 1 || e.ctrlKey || e.metaKey) {
          return;
        }

        e.preventDefault();
        navigate(href, { replace: true });

        scrollToSection(link.id);
      }}
      href={href}
    >
      {link.label}
      {link.names && link.names.length > 0 ? <CpErrorWarningArrayIconLink names={link.names} /> : null}
    </a>
  );
};
